import { useEffect, useMemo } from "react";
import { useLocale } from "../i18n/LocaleContext";

const SPARK_COUNT = 56;
const BURST_MS = 720;

function makeSparks(key) {
  return Array.from({ length: SPARK_COUNT }, (_, i) => ({
    id: `${key}-${i}`,
    left: 4 + Math.random() * 92,
    top: 4 + Math.random() * 92,
    size: 10 + Math.random() * 14,
    delay: Math.random() * 0.12,
    duration: 0.45 + Math.random() * 0.35,
    rotation: Math.random() * 360,
    kind: Math.random() > 0.55 ? "star" : "sparkle",
  }));
}

export function LocaleSparkOverlay() {
  const { sparkKey } = useLocale();

  const sparks = useMemo(
    () => (sparkKey > 0 ? makeSparks(sparkKey) : []),
    [sparkKey]
  );

  useEffect(() => {
    if (sparkKey === 0) return;
    document.body.classList.add("locale-burst");
    const t = setTimeout(() => document.body.classList.remove("locale-burst"), BURST_MS);
    return () => {
      clearTimeout(t);
      document.body.classList.remove("locale-burst");
    };
  }, [sparkKey]);

  if (!sparks.length) return null;

  return (
    <div
      className="locale-spark-layer"
      aria-hidden="true"
    >
      <div className="locale-spark-flash" />
      {sparks.map((s) => (
        <span
          key={s.id}
          className={`locale-spark ${s.kind === "star" ? "locale-spark--star" : "locale-spark--emoji"}`}
          style={{
            left: `${s.left}%`,
            top: `${s.top}%`,
            width: s.size,
            height: s.size,
            animationDelay: `${s.delay}s`,
            animationDuration: `${s.duration}s`,
            "--spark-rot": `${s.rotation}deg`,
          }}
        >
          {s.kind === "sparkle" ? "✨" : null}
        </span>
      ))}
    </div>
  );
}
